function checkTerms() {
    if(!jQuery('body').hasClass('home')) {
        return;
    }
    var $ = jQuery.noConflict();

    var term_key = "terms102017";

    var user = get_current_user();

    if(user != undefined && user.id != undefined && this_user_has_role("Administrator") && user.agreedTo.indexOf(term_key) < 0) {
        $.squdeAjaxPopup({
            url: '/terms',
            secured: true,
            data: {key: term_key},
            onOpen: function (elm, popup) {
                elm.find('form').bind('success', function() {
                    popup.close();
                });
            }
        });
        return false;
    }
}
function agreeTerms(sender, key) {
    var form = jQuery(sender);
    if(form.find('#agree-box').is(':checked')) {
        jQuery.post('/terms/agreed', {key: key}, function() {
            jQuery.get('/ajax/getCurrentUser', function(data) {
                setCookie("current_user", data);
                form.trigger('success');
            });
        });
    } else {
        squde_flash("Ga akkoord met de voorwaarden om verder te gaan", "alert");
    }
    return false;
}